__turbopack_context__.v({
  "arrows": "SourcesChart-module__2vhQ_W__arrows",
  "arrowsSvg": "SourcesChart-module__2vhQ_W__arrowsSvg",
  "axis": "SourcesChart-module__2vhQ_W__axis",
  "axisTitle": "SourcesChart-module__2vhQ_W__axisTitle",
  "bandAds": "SourcesChart-module__2vhQ_W__bandAds",
  "bandSeo": "SourcesChart-module__2vhQ_W__bandSeo",
  "bands": "SourcesChart-module__2vhQ_W__bands",
  "barsCaption": "SourcesChart-module__2vhQ_W__barsCaption",
  "chart": "SourcesChart-module__2vhQ_W__chart",
  "end": "SourcesChart-module__2vhQ_W__end",
  "figure": "SourcesChart-module__2vhQ_W__figure",
  "figureImage": "SourcesChart-module__2vhQ_W__figureImage",
  "footnote": "SourcesChart-module__2vhQ_W__footnote",
  "footnoteLabel": "SourcesChart-module__2vhQ_W__footnoteLabel",
  "guide": "SourcesChart-module__2vhQ_W__guide",
  "hatchGround": "SourcesChart-module__2vhQ_W__hatchGround",
  "hatchLine": "SourcesChart-module__2vhQ_W__hatchLine",
  "introStrong": "SourcesChart-module__2vhQ_W__introStrong",
  "level": "SourcesChart-module__2vhQ_W__level",
  "milestone": "SourcesChart-module__2vhQ_W__milestone",
  "milestoneTag": "SourcesChart-module__2vhQ_W__milestoneTag",
  "note": "SourcesChart-module__2vhQ_W__note",
  "panel": "SourcesChart-module__2vhQ_W__panel",
  "pencil": "SourcesChart-module__2vhQ_W__pencil",
  "pencilHatch": "SourcesChart-module__2vhQ_W__pencilHatch",
  "pencilHatchLight": "SourcesChart-module__2vhQ_W__pencilHatchLight",
  "pillar": "SourcesChart-module__2vhQ_W__pillar",
  "pillars": "SourcesChart-module__2vhQ_W__pillars",
  "pillarsCols": "SourcesChart-module__2vhQ_W__pillarsCols",
  "pillarsIcon": "SourcesChart-module__2vhQ_W__pillarsIcon",
  "pillarsText": "SourcesChart-module__2vhQ_W__pillarsText",
  "pillarsTitle": "SourcesChart-module__2vhQ_W__pillarsTitle",
  "plot": "SourcesChart-module__2vhQ_W__plot",
  "section": "SourcesChart-module__2vhQ_W__section",
  "tick": "SourcesChart-module__2vhQ_W__tick",
  "titleMuted": "SourcesChart-module__2vhQ_W__titleMuted",
  "washAds": "SourcesChart-module__2vhQ_W__washAds",
  "washSeo": "SourcesChart-module__2vhQ_W__washSeo",
  "wordEdge": "SourcesChart-module__2vhQ_W__wordEdge",
});
